import { Common_mkId, Common_isAllowed, Common_containerWithContent } from "./Common/Common.js";
import { view } from "./Auth/LoginView.js";
import { Msg } from "./Types.js";
import { viewRequestResetEmail, view as view_1 } from "./Auth/ResetView.js";
import { view as view_2 } from "./Auth/RegisterView.js";
import { view as view_3 } from "./Auth/EmailChangeView.js";
import { view as view_4 } from "./TelepathologyGuest/TelepathologyGuestView.js";
import { view as view_5 } from "./Users/UsersView.js";
import { view as view_6 } from "./Accounts/AccountsView.js";
import { view as view_7 } from "./Sites/SitesView.js";
import { view as view_8 } from "./AuthorizedSites/AuthorizedSitesView.js";
import { view as view_9 } from "./Devices/DevicesView.js";
import { view as view_10 } from "./Patients/PatientSearchView.js";
import { view as view_11 } from "./InForm/InFormView.js";
import { view as view_12 } from "./UserProfile/UserProfileView.js";
import { view as view_13 } from "./Dashboard/DashboardView.js";
import { TextAlignment_Option, Common_GenericOption, Color_IColor, Modifier_IModifier, Screen, Text_div } from "./fable_modules/Fulma.2.16.0/Common.fs.js";
import { map, collect, ofArray, singleton, empty } from "./fable_modules/fable-library.3.7.12/List.js";
import { UserRole_get_describe, Permission } from "./Optiscan.Models/Security.js";
import { Helpers_nothing } from "./fable_modules/Fable.React.7.4.3/Fable.React.Helpers.fs.js";
import { Option, ISize, column } from "./fable_modules/Fulma.2.16.0/Layouts/Column.fs.js";
import { DOMAttr, HTMLAttr } from "./fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { Option as Option_1, content as content_17 } from "./fable_modules/Fulma.2.16.0/Elements/Content.fs.js";
import { icon as icon_1, Block_Option, Block_a, panel as panel_1 } from "./fable_modules/Fulma.2.16.0/Components/Panel.fs.js";
import { empty as empty_1, singleton as singleton_1, append, delay, toList } from "./fable_modules/fable-library.3.7.12/Seq.js";
import { Naming_UIElement } from "./fable_modules/Webbler.Models.1.2.6/Common.fs.js";
import { equals } from "./fable_modules/fable-library.3.7.12/Util.js";
import { Option as Option_2, icon as icon_2 } from "./fable_modules/Fulma.2.16.0/Elements/Icon.fs.js";
import { Fa_IconOption, Fa_i } from "./fable_modules/Fable.FontAwesome.2.0.0/FontAwesome.fs.js";
import { Page } from "./Pages.js";
import { End_div, menu as menu_1, Item_Option, Item_a, Burger_Option, burger, Item_div, Brand_div, Option as Option_3, navbar as navbar_1 } from "./fable_modules/Fulma.2.16.0/Components/Navbar.fs.js";
import * as react from "react";
import { Common_EmailAddress_value_Z39D6D3C1 } from "./fable_modules/Webbler.Models.1.2.6/Api.fs.js";
import { keyValueList } from "./fable_modules/fable-library.3.7.12/MapUtil.js";
import { join } from "./fable_modules/fable-library.3.7.12/String.js";
import { left, right, Item_Option as Item_Option_1, item, Level_Option, level } from "./fable_modules/Fulma.2.16.0/Layouts/Level.fs.js";
import { sessionExpiryModal, view as view_14 } from "./Auth/AuthView.js";
import { image } from "./fable_modules/Fulma.2.16.0/Elements/Image.fs.js";
import { map as map_1, defaultArg } from "./fable_modules/fable-library.3.7.12/Option.js";
import { clientVersion } from "./Version.js";
import { Option as Option_4, columns } from "./fable_modules/Fulma.2.16.0/Layouts/Columns.fs.js";

export function root(model, dispatch) {
    let props, children, children_2, props_13, children_19, children_21;
    let content_15;
    const matchValue = model.CurrentPage;
    let pattern_matching_result;
    if (matchValue.tag === 0) {
        if (matchValue.fields[0].tag === 1) {
            pattern_matching_result = 1;
        }
        else if (matchValue.fields[0].tag === 3) {
            pattern_matching_result = 2;
        }
        else if (matchValue.fields[0].tag === 4) {
            pattern_matching_result = 3;
        }
        else if (matchValue.fields[0].tag === 2) {
            pattern_matching_result = 4;
        }
        else {
            pattern_matching_result = 0;
        }
    }
    else if (matchValue.tag === 1) {
        pattern_matching_result = 5;
    }
    else if (matchValue.tag === 8) {
        if (Common_isAllowed(new Permission(8))(model.AuthModel.UserInfo)) {
            pattern_matching_result = 6;
        }
        else {
            pattern_matching_result = 7;
        }
    }
    else {
        pattern_matching_result = 7;
    }
    switch (pattern_matching_result) {
        case 0: {
            content_15 = Common_containerWithContent("Login", view(model.AuthModel, (arg) => {
                dispatch(new Msg(2, arg));
            }));
            break;
        }
        case 1: {
            content_15 = Common_containerWithContent("Reset Password", view_1(model.AuthModel, (arg_1) => {
                dispatch(new Msg(2, arg_1));
            }));
            break;
        }
        case 2: {
            content_15 = Common_containerWithContent("Reset Password", viewRequestResetEmail(model.AuthModel.ResetRequestEmail, (arg_2) => {
                dispatch(new Msg(2, arg_2));
            }));
            break;
        }
        case 3: {
            content_15 = Common_containerWithContent("Register", view_2(model.AuthModel, (arg_3) => {
                dispatch(new Msg(2, arg_3));
            }));
            break;
        }
        case 4: {
            content_15 = Common_containerWithContent("Change Email", view_3(model.AuthModel, (arg_4) => {
                dispatch(new Msg(2, arg_4));
            }));
            break;
        }
        case 5: {
            content_15 = Common_containerWithContent("Telepathology Guest", view_4(model.TelepathologyGuestModel, (arg_5) => {
                dispatch(new Msg(3, arg_5));
            }));
            break;
        }
        case 6: {
            content_15 = Common_containerWithContent("Users", view_5(model.UsersModel, (arg_6) => {
                dispatch(new Msg(7, arg_6));
            }));
            break;
        }
        case 7: {
            let pattern_matching_result_1;
            if (matchValue.tag === 2) {
                if (Common_isAllowed(new Permission(15))(model.AuthModel.UserInfo)) {
                    pattern_matching_result_1 = 0;
                }
                else {
                    pattern_matching_result_1 = 1;
                }
            }
            else {
                pattern_matching_result_1 = 1;
            }
            switch (pattern_matching_result_1) {
                case 0: {
                    content_15 = Common_containerWithContent("Accounts", view_6(model.AccountsModel, (arg_7) => {
                        dispatch(new Msg(4, arg_7));
                    }));
                    break;
                }
                case 1: {
                    let pattern_matching_result_2;
                    if (matchValue.tag === 3) {
                        if (Common_isAllowed(new Permission(22))(model.AuthModel.UserInfo)) {
                            pattern_matching_result_2 = 0;
                        }
                        else {
                            pattern_matching_result_2 = 1;
                        }
                    }
                    else {
                        pattern_matching_result_2 = 1;
                    }
                    switch (pattern_matching_result_2) {
                        case 0: {
                            content_15 = Common_containerWithContent("Sites", view_7(model.SitesModel, (arg_8) => {
                                dispatch(new Msg(5, arg_8));
                            }));
                            break;
                        }
                        case 1: {
                            let pattern_matching_result_3;
                            if (matchValue.tag === 4) {
                                if (Common_isAllowed(new Permission(33))(model.AuthModel.UserInfo)) {
                                    pattern_matching_result_3 = 0;
                                }
                                else {
                                    pattern_matching_result_3 = 1;
                                }
                            }
                            else {
                                pattern_matching_result_3 = 1;
                            }
                            switch (pattern_matching_result_3) {
                                case 0: {
                                    content_15 = view_8(model.AuthorizedSitesModel, (arg_9) => {
                                        dispatch(new Msg(6, arg_9));
                                    });
                                    break;
                                }
                                case 1: {
                                    let pattern_matching_result_4;
                                    if (matchValue.tag === 5) {
                                        if (Common_isAllowed(new Permission(26))(model.AuthModel.UserInfo)) {
                                            pattern_matching_result_4 = 0;
                                        }
                                        else {
                                            pattern_matching_result_4 = 1;
                                        }
                                    }
                                    else {
                                        pattern_matching_result_4 = 1;
                                    }
                                    switch (pattern_matching_result_4) {
                                        case 0: {
                                            content_15 = Common_containerWithContent("Devices", view_9(model.DevicesModel, (arg_10) => {
                                                dispatch(new Msg(8, arg_10));
                                            }));
                                            break;
                                        }
                                        case 1: {
                                            let pattern_matching_result_5;
                                            if (matchValue.tag === 6) {
                                                if (Common_isAllowed(new Permission(28))(model.AuthModel.UserInfo)) {
                                                    pattern_matching_result_5 = 0;
                                                }
                                                else {
                                                    pattern_matching_result_5 = 1;
                                                }
                                            }
                                            else {
                                                pattern_matching_result_5 = 1;
                                            }
                                            switch (pattern_matching_result_5) {
                                                case 0: {
                                                    content_15 = Common_containerWithContent("Patient Search", view_10(model.PatientSearchModel, (arg_11) => {
                                                        dispatch(new Msg(9, arg_11));
                                                    }));
                                                    break;
                                                }
                                                case 1: {
                                                    let pattern_matching_result_6;
                                                    if (matchValue.tag === 7) {
                                                        if (Common_isAllowed(new Permission(29))(model.AuthModel.UserInfo)) {
                                                            pattern_matching_result_6 = 0;
                                                        }
                                                        else {
                                                            pattern_matching_result_6 = 1;
                                                        }
                                                    }
                                                    else {
                                                        pattern_matching_result_6 = 1;
                                                    }
                                                    switch (pattern_matching_result_6) {
                                                        case 0: {
                                                            content_15 = Common_containerWithContent("InForm", view_11(model.InFormModel, (arg_12) => {
                                                                dispatch(new Msg(10, arg_12));
                                                            }));
                                                            break;
                                                        }
                                                        case 1: {
                                                            let pattern_matching_result_7;
                                                            if (matchValue.tag === 9) {
                                                                if (Common_isAllowed(new Permission(6))(model.AuthModel.UserInfo)) {
                                                                    pattern_matching_result_7 = 0;
                                                                }
                                                                else {
                                                                    pattern_matching_result_7 = 1;
                                                                }
                                                            }
                                                            else {
                                                                pattern_matching_result_7 = 1;
                                                            }
                                                            switch (pattern_matching_result_7) {
                                                                case 0: {
                                                                    content_15 = Common_containerWithContent("User Profile", view_12(model.UserProfileModel, (arg_13) => {
                                                                        dispatch(new Msg(12, arg_13));
                                                                    }));
                                                                    break;
                                                                }
                                                                case 1: {
                                                                    let pattern_matching_result_8;
                                                                    if (matchValue.tag === 10) {
                                                                        if (Common_isAllowed(new Permission(40))(model.AuthModel.UserInfo)) {
                                                                            pattern_matching_result_8 = 0;
                                                                        }
                                                                        else {
                                                                            pattern_matching_result_8 = 1;
                                                                        }
                                                                    }
                                                                    else {
                                                                        pattern_matching_result_8 = 1;
                                                                    }
                                                                    switch (pattern_matching_result_8) {
                                                                        case 0: {
                                                                            content_15 = Common_containerWithContent("Dashboard", view_13(model.DashboardModel, (arg_14) => {
                                                                                dispatch(new Msg(13, arg_14));
                                                                            }));
                                                                            break;
                                                                        }
                                                                        case 1: {
                                                                            content_15 = Common_containerWithContent("Default", Text_div(empty(), singleton("Woops, looks like you took a wrong turn somewhere!")));
                                                                            break;
                                                                        }
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                            break;
                                                        }
                                                    }
                                                    break;
                                                }
                                            }
                                            break;
                                        }
                                    }
                                    break;
                                }
                            }
                            break;
                        }
                    }
                    break;
                }
            }
            break;
        }
    }
    const menu = (model.AuthModel.UserInfo == null) ? Helpers_nothing : column(ofArray([new Option(0, new Screen(0), new ISize(17)), new Option(3, singleton(new HTMLAttr(64, "side-menu")))]), singleton(content_17(singleton(new Option_1(3, singleton(new Modifier_IModifier(24, new Screen(0), !model.MenuIsExpanded)))), singleton(panel_1(empty(), collect((page) => {
        let linkedPage, label;
        return singleton((linkedPage = page.Page, (label = page.Label, Block_a(toList(delay(() => append(singleton_1(new Block_Option(1, ofArray([Common_mkId("NavMenu", label, new Naming_UIElement(5)), new DOMAttr(40, (_arg1) => {
            dispatch(new Msg(1, linkedPage));
        }), ["style", {
            paddingRight: "2rem",
        }]]))), delay(() => (equals(linkedPage, model.CurrentPage) ? singleton_1(new Block_Option(0, true)) : empty_1()))))), ofArray([icon_1(empty(), singleton(icon_2(singleton(new Option_2(4, singleton(["style", {
            justifyContent: "revert",
            alignItems: "baseline",
        }]))), singleton(Fa_i(singleton(page.Icon), []))))), label])))));
    }, toList(delay(() => append(Common_isAllowed(new Permission(40))(model.AuthModel.UserInfo) ? singleton_1({
        Icon: new Fa_IconOption(11, "fas fa-chart-bar"),
        Label: "Dashboard",
        Page: new Page(10),
    }) : empty_1(), delay(() => append(Common_isAllowed(new Permission(8))(model.AuthModel.UserInfo) ? singleton_1({
        Icon: new Fa_IconOption(11, "fas fa-users"),
        Label: "Users",
        Page: new Page(8),
    }) : empty_1(), delay(() => append(Common_isAllowed(new Permission(15))(model.AuthModel.UserInfo) ? singleton_1({
        Icon: new Fa_IconOption(11, "fas fa-file"),
        Label: "Accounts",
        Page: new Page(2),
    }) : empty_1(), delay(() => append(Common_isAllowed(new Permission(26))(model.AuthModel.UserInfo) ? singleton_1({
        Icon: new Fa_IconOption(11, "fas fa-desktop"),
        Label: "Devices",
        Page: new Page(5),
    }) : empty_1(), delay(() => append(Common_isAllowed(new Permission(28))(model.AuthModel.UserInfo) ? singleton_1({
        Icon: new Fa_IconOption(11, "fas fa-hospital"),
        Label: "Patient Search",
        Page: new Page(6, void 0, void 0),
    }) : empty_1(), delay(() => append(Common_isAllowed(new Permission(29))(model.AuthModel.UserInfo) ? singleton_1({
        Icon: new Fa_IconOption(11, "fas fa-microscope"),
        Label: "InForm",
        Page: new Page(7, void 0),
    }) : empty_1(), delay(() => (Common_isAllowed(new Permission(33))(model.AuthModel.UserInfo) ? singleton_1({
        Icon: new Fa_IconOption(11, "fas fa-user-check"),
        Label: "Authorized Sites",
        Page: new Page(4),
    }) : empty_1())))))))))))))))))))));
    let navbar;
    const matchValue_2 = model.AuthModel.UserInfo;
    if (matchValue_2 == null) {
        navbar = navbar_1(singleton(new Option_3(0, new Color_IColor(4))), singleton(Brand_div(empty(), ofArray([Item_div(empty(), singleton(burger(ofArray([new Burger_Option(0, model.MenuIsExpanded), new Burger_Option(2, ofArray([new HTMLAttr(99, "NavbarBurger"), new DOMAttr(40, (e_1) => {
            dispatch(new Msg(14, !model.MenuIsExpanded));
        }), new HTMLAttr(135, "button"), ["style", {
            marginLeft: "0px",
            display: "block",
        }]]))]), ofArray([react.createElement("span", {}), react.createElement("span", {}), react.createElement("span", {})])))), Item_div(empty(), singleton(react.createElement("img", {
            src: "logo.png",
        })))]))));
    }
    else {
        const ui_1 = matchValue_2;
        let describeUser;
        const children_4 = [(props = [["style", {
            marginRight: 10,
        }]], (children = [Common_EmailAddress_value_Z39D6D3C1(ui_1.email)], react.createElement("span", keyValueList(props, 1), ...children))), (children_2 = [join(",", map(UserRole_get_describe(), ui_1.roles))], react.createElement("span", {}, ...children_2))];
        describeUser = react.createElement(react.Fragment, {}, ...children_4);
        navbar = navbar_1(singleton(new Option_3(6, singleton(new HTMLAttr(99, "header")))), ofArray([Brand_div(singleton(new Common_GenericOption(1, singleton(["style", {
            flexWrap: "Wrap",
        }]))), ofArray([Item_div(empty(), singleton(burger(ofArray([new Burger_Option(0, model.MenuIsExpanded), new Burger_Option(2, ofArray([new HTMLAttr(99, "NavbarBurger"), new DOMAttr(40, (e) => {
            dispatch(new Msg(14, !model.MenuIsExpanded));
        }), new HTMLAttr(135, "button"), ["style", {
            marginLeft: "0px",
            display: "block",
        }]]))]), ofArray([react.createElement("span", {}), react.createElement("span", {}), react.createElement("span", {})])))), Item_div(empty(), singleton(react.createElement("img", {
            src: "logo.png",
        }))), Item_a(ofArray([new Item_Option(7, singleton(new Modifier_IModifier(24, new Screen(1), true))), new Item_Option(5, singleton(["style", {
            flexGrow: 1,
        }]))]), singleton(level(ofArray([new Level_Option(0, singleton(["style", {
            flexGrow: 1,
        }])), new Level_Option(1)]), ofArray([item(singleton(new Item_Option_1(0, singleton(["style", {
            flexGrow: 1,
        }]))), empty()), right(empty(), singleton(item(empty(), singleton(view_14(model.AuthModel, (arg_15) => {
            dispatch(new Msg(2, arg_15));
        })))))]))))])), menu_1(empty(), singleton(End_div(empty(), ofArray([Item_div(empty(), singleton(image(empty(), singleton((props_13 = [new HTMLAttr(65, "is-rounded"), ["style", {
            cursor: "pointer",
        }], new DOMAttr(40, (_arg2) => {
            dispatch(new Msg(1, new Page(9)));
        }), new HTMLAttr(149, "blank-profile-picture.png")], react.createElement("img", keyValueList(props_13, 1))))))), defaultArg(map_1((ui_2) => Item_div(empty(), singleton(describeUser)), model.AuthModel.UserInfo), Helpers_nothing), Item_div(empty(), singleton(view_14(model.AuthModel, (arg_16) => {
            dispatch(new Msg(2, arg_16));
        })))]))))]));
    }
    const footerContents = Brand_div(singleton(new Common_GenericOption(1, singleton(["style", {
        flexGrow: "1",
        height: "inherit",
        minHeight: "inherit",
    }]))), singleton(level(ofArray([new Level_Option(0, singleton(new HTMLAttr(99, "footer-level"))), new Level_Option(1)]), ofArray([left(empty(), empty()), right(empty(), singleton(item(empty(), singleton(content_17(singleton(new Option_1(3, singleton(new Modifier_IModifier(5, new Screen(0), new TextAlignment_Option(0))))), singleton((children_19 = ["Version ", react.createElement("strong", {}, clientVersion)], react.createElement("p", {}, ...children_19))))))))]))));
    document.getElementById("app-container").classList.add("theme-dark");
    const children_23 = [navbar, (children_21 = [columns(ofArray([new Option_4(3), new Option_4(9, singleton(["style", {
        marginBottom: "0px",
    }]))]), ofArray([menu, column(singleton(new Option(3, singleton(["style", {
        overflowX: "hidden",
    }]))), singleton(content_15))]))], react.createElement("div", {
        className: "main-div",
    }, ...children_21)), sessionExpiryModal(model.AuthModel.Inactivity, (arg_17) => {
        dispatch(new Msg(2, arg_17));
    }), navbar_1(ofArray([new Option_3(6, singleton(new HTMLAttr(99, "footer-desktop"))), new Option_3(4), new Option_3(2), new Option_3(8, singleton(new Modifier_IModifier(24, new Screen(5), true)))]), singleton(footerContents)), navbar_1(ofArray([new Option_3(6, singleton(new HTMLAttr(99, "footer-touch"))), new Option_3(8, singleton(new Modifier_IModifier(24, new Screen(1), true)))]), singleton(footerContents))];
    return react.createElement("div", {
        id: "top-level-div",
    }, ...children_23);
}

